import { render } from "./header_mbl.vue?vue&type=template&id=140166a6&scoped=true"
import script from "./header_mbl.vue?vue&type=script&lang=js"
export * from "./header_mbl.vue?vue&type=script&lang=js"

import "./header_mbl.vue?vue&type=style&index=0&id=140166a6&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140166a6"]])

export default __exports__